import CryptoJS from 'crypto-js'

/**
 * Генерирует MD5 хеш из текущей даты (в московском часовом поясе) и секретного ключа
 * @param {string} secretKey - Секретный ключ для подписи
 * @returns {string} MD5 хеш в формате hex
 */
export function generateAuthHash(secretKey) {
  // Получаем текущее время в московском часовом поясе (UTC+3)
  const now = new Date()
  const mskTime = new Date(now.getTime() + 3 * 60 * 60 * 1000)

  // Форматируем дату в "Y-m-d H:i" (например: "2023-12-31 23:59")
  const formattedDate =
    `${[
      mskTime.getUTCFullYear(),
      String(mskTime.getUTCMonth() + 1).padStart(2, '0'),
      String(mskTime.getUTCDate()).padStart(2, '0'),
    ].join('-')
    } ${
    [
      String(mskTime.getUTCHours()).padStart(2, '0'),
      String(mskTime.getUTCMinutes()).padStart(2, '0'),
    ].join(':')}`

  // Соединяем с секретным ключом и хешируем
  return CryptoJS.MD5(formattedDate + secretKey).toString()
}
